import React from "react";
import { useNavigate } from "react-router-dom";
import { fetchDirectory, removePath } from "../api/directorySlice";
import { useAppDispatch } from "../utils/hooks";
import { PathItemProps } from "../types/types";
import { getPathItemStyles } from "../styles/styles";
import { useTheme } from "../contexts/ThemeContext";

export const PathItem: React.FC<PathItemProps> = ({
  name,
  id,
  pathArray,
  index,
}) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { theme } = useTheme();

  const isFirst = pathArray[0].name === name;
  const isLast = pathArray[pathArray.length - 1].name === name;

  const handleChangePath = (id: string | null, index: number) => {
    dispatch(removePath(index));
    dispatch(fetchDirectory({ directoryId: id, addToPath: false }));
    if (index === 0) {
      navigate("/");
    } else {
      navigate(`/dir/${id}`);
    }
  };

  const displayText =
    pathArray.length > 2
      ? !isFirst && !isLast
        ? ` / ${name} / `
        : name
      : isFirst
      ? name
      : ` / ${name}`;

  return (
    <span
      style={getPathItemStyles(theme)}
      onClick={() => handleChangePath(id, index)}
    >
      {displayText}
    </span>
  );
};
